import { initCursorBlink, initSequentialAnimations } from './animations.js';
import * as commandLineModule from './commandLine.js';
import * as contactFormModule from './contactForm.js';
import {
	createMatrixRain,
	initGlitchEffects,
	initParticleSystem,
	initProjectCardEffects,
} from './effects.js';
import * as translationsModule from './translations.js';
import { initPerformanceOptimizations } from './performance.js';

// Make modules available globally for cross-module communication
window.translationsModule = translationsModule;
window.commandLineModule = commandLineModule;
window.contactFormModule = contactFormModule;


document.addEventListener('DOMContentLoaded', function () {
	// Initialize performance optimizations first
	initPerformanceOptimizations();

	// Set initial language and page title
	document.title =
		translationsModule.translations[
			translationsModule.currentLanguage
		].title;

	// Initialize translations system
	translationsModule.updateTranslations();

	// Matrix Rain Effect
	createMatrixRain();

	// Initialize sequential section animations
	initSequentialAnimations();

	// Add glitch effects
	initGlitchEffects();

	// Initialize particle system
	initParticleSystem();

	// Initialize cursor blink
	initCursorBlink();

	// Initialize project card effects
	initProjectCardEffects();

	// Initialize Feather icons
	feather.replace();
});
